/**
 * The wrap-up segment's step ids, in the order they sit in the signup step
 * list. Kept free of imports so the step list can include it without a cycle.
 */
export const WRAP_UP_STEPS = [
  'wrap-up',
  'hdhp-notice',
  'hdhp-booking',
  'rewards-intro',
  'rewards-points',
  'call-choice',
  'language-preference',
  'booking',
  'booking-unavailable',
] as const;

export type WrapUpStepId = (typeof WRAP_UP_STEPS)[number];

/** The last id in the segment; the flow leaves to whatever step follows it. */
export const LAST_WRAP_UP_STEP: WrapUpStepId = 'booking-unavailable';
